import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import '../css/cards/CardsBlogPortalOneOFThree.css';

import React from 'react';
import removeCssFromACode from '../../../../util/removeCssFromACode';
import extractTextFromHtml from '../../../../util/extractTextAndWrapInH3';
import { createSlug } from '../../../../util/urlHelpers';

export const CardsBlogPortalOneOFThree = ({ cardData }) => {
  const cardId = cardData?.id;
  const params = useParams();
  const lang = params?.lang;
  const history = useHistory();
  const h1match = cardData?.content?.match(/<h1[^>]*>([\s\S]*?)<\/h1>/);
  const h1Element = h1match ? h1match[1] : '';
  const firstImage = cardData?.featuredImage;
  const firstH1Match = cardData?.content?.match(/<h1[^>]*>[\s\S]*?<\/h1>/);
  const title = cardData?.title;
  const handelClick = () => {
    history.push(`/${lang}/blog/q?&id=${cardId}${title ? '&name=' + createSlug(title) : ''}`);
  };
  return (
    <div
      onClick={handelClick}
      // style={{ backgroundImage: `url(${firstImage?.url})` }}
      className="movie-card movie-card_css"
    >
      <div style={{ backgroundImage: `url(${firstImage})` }} className="image_card"></div>
      <div>
        <h2 className="movie-card-title">{cardData?.title}</h2>
        <div className="movie-card-buttons">
          <a href={''} className="movie-card-button">
            Leer más
          </a>
        </div>
      </div>
    </div>
  );
};
